import { nowIso } from '../domain/time.js';
export class TombstoneRepository {
    driver;
    constructor(driver) {
        this.driver = driver;
    }
    async record(entity, entityId, at = nowIso()) {
        // Portable update-then-insert (minSdk 26 SQLite has no upsert; ADR-002).
        await this.driver.batch([
            { sql: 'UPDATE tombstones SET at = ? WHERE entity = ? AND entity_id = ?', params: [at, entity, entityId] },
            {
                sql: `INSERT INTO tombstones (entity, entity_id, at)
              SELECT ?, ?, ? WHERE (SELECT changes()) = 0`,
                params: [entity, entityId, at],
            },
        ]);
    }
    async has(entity, entityId) {
        const rows = await this.driver.query({
            sql: 'SELECT 1 AS present FROM tombstones WHERE entity = ? AND entity_id = ?',
            params: [entity, entityId],
        });
        return rows.length > 0;
    }
    async list(entity) {
        const rows = entity
            ? await this.driver.query({ sql: 'SELECT * FROM tombstones WHERE entity = ? ORDER BY at', params: [entity] })
            : await this.driver.query({ sql: 'SELECT * FROM tombstones ORDER BY at' });
        return rows.map((r) => ({ entity: String(r.entity), entityId: String(r.entity_id), at: String(r.at) }));
    }
}
//# sourceMappingURL=tombstones.js.map